import React from 'react'
import { IoHardwareChip } from 'react-icons/io5'
import TechnologyServicePage from '../components/TechnologyServicePage'

const capabilities = [
    { title: 'Managed IT Services', description: 'Day-to-day support for reliable business technology operations.' },
    { title: 'Application Support', description: 'Keep critical software stable, updated, and available.' },
    { title: 'Infrastructure Management', description: 'Monitor servers, networks, cloud resources, and core systems.' },
    { title: 'Database Administration', description: 'Maintain secure, optimized, and dependable data environments.' },
    { title: 'Cloud Operations', description: 'Manage cloud workloads, backups, availability, and performance.' },
    { title: 'Help Desk Services', description: 'Responsive user support for technical issues and requests.' },
    { title: 'Remote Monitoring', description: 'Track system health before small issues become outages.' },
    { title: 'Preventive Maintenance', description: 'Routine checks that keep systems secure and efficient.' },
    { title: 'Performance Optimization', description: 'Improve speed, reliability, and resource usage across systems.' }
]

const ManagedServices = () => (
    <TechnologyServicePage
        badge="Managed Services"
        title="Reliable technology operations without the daily overhead."
        description="We manage applications, infrastructure, cloud operations, databases, monitoring, and user support so your teams can focus on growth."
        metaDescription="Managed IT services, application support, infrastructure management, cloud operations, database administration, and help desk support."
        icon={<IoHardwareChip className="text-sm" />}
        capabilities={capabilities}
        outcomes={[
            { title: 'Always supported', description: 'Technical help and system care when your organization needs it.' },
            { title: 'Less downtime', description: 'Monitoring and preventive maintenance reduce avoidable disruption.' },
            { title: 'Better performance', description: 'Continuous optimization keeps platforms responsive and dependable.' }
        ]}
        highlights={[
            { title: 'Monitor', description: 'Track infrastructure, applications, and cloud services continuously.' },
            { title: 'Maintain', description: 'Apply preventive care, database checks, and technical support.' },
            { title: 'Improve', description: 'Optimize performance and reliability as your usage grows.' }
        ]}
        cta={{
            eyebrow: 'Managed with care',
            title: 'Keep your systems secure, stable, and ready for work.',
            description: 'Our managed services give you dependable technical support without slowing your core team down.'
        }}
    />
)

export default ManagedServices
